import { SORT_DIRECTIONS, TOP_SORT_DIRECTION } from '../../constants';
import React from 'react';

import Grid from '@mui/material/Grid2';
import InputItem from '../../../InputList/inputItem';
import MenuButton from '../../../MenuButton';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  label: {
    ...theme.palette.alternateText,
    fontWeight: 'bold',
  },
  inputItemRoot: {
    '& > .MuiOutlinedInput-root': {
      fontSize: '0.7rem',
      width: '55px',
    },
  },
}));

export default ({
  aggregate,
  handleSetAggregate,
  handleSetState,
  isDisabled,
  itemIsDisabledProps = {},
  limit,
  sortDirection = TOP_SORT_DIRECTION,
  sortMetric,
  sortTypes,
}) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" style={{ width: '100%' }}>
      <Typography className={classes.label} variant="overline">
        Display Settings
      </Typography>
      <Grid
        container
        direction="row"
        style={{ flexWrap: 'nowrap' }}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography style={{ width: '65px', fontWeight: 'bold' }}>Display: </Typography>
        <MenuButton
          context={aggregate}
          items={SORT_DIRECTIONS}
          isDisabled={isDisabled}
          selectedItem={sortDirection}
          onChange={(newSort) => {
            if (newSort.limit !== undefined) {
              handleSetAggregate(aggregate, newSort.limit, newSort);
            } else {
              handleSetState(newSort, 'sortDirection');
            }
          }}
          tooltip="Select whether you want the top or bottom x results."
        />
        <InputItem
          styles={classes}
          inputLabel="Limit"
          value={limit}
          onChange={(e) => {
            // Only allow postive integers and null string
            if (e.target.value.match(/^(\d|\|)*$/)) {
              handleSetState(e.target.value, 'limit');
            }
          }}
          isDisabled={isDisabled || sortDirection.limit !== undefined} // All sort direction has a default limit of 0
        />
      </Grid>
      <Grid
        container
        direction="row"
        style={{ flexWrap: 'nowrap' }}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography style={{ width: '65px', fontWeight: 'bold' }}>Based on: </Typography>
        <MenuButton
          context="sort-metric"
          items={sortTypes}
          isDisabled={isDisabled}
          itemIsDisabledProps={itemIsDisabledProps}
          selectedItem={sortMetric}
          onChange={(newSortMetric) => {
            handleSetState(newSortMetric, 'sortMetric');
          }}
          tooltip="Select which metric to sort the data by."
        />
      </Grid>
    </Grid>
  );
};
